<template>
    <div>
        <div class="vehica-checkbox">
            <input type="checkbox"
                   :id="id"
                   :name="id"
                   v-model="value"
                   :disabled="disabled">
            <label :for="id"><slot></slot></label>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['disabled', 'id', 'modelValue'],
        emits: ['input', 'update:model-value'],
        data: function () {
            return {
                value: false,
            };
        },
        created() {
            this.value = this.modelValue;
        },
        watch: {
            modelValue(v) {
                this.value = v;
            },
            value() {
                this.$emit('input', this.value);
                this.$emit('update:model-value', this.value);
            }
        }
    }
</script>